export { default } from "./getArticleAndAnnotationsData";
